import { defineMessages } from 'react-intl';

export const managementReportResourceCostBreakdownSummaryTableMessageDefinitions = defineMessages({
  emptyTableText: {
    id: 'estimation.detail.managementReport.resourceCostBreakdownSummaryTable.emptyTableText',
    defaultMessage: 'No resource cost items to display',
  },
  projectPhase: {
    id: 'estimation.detail.managementReport.resourceCostBreakdownSummaryTable.projectPhase',
    defaultMessage: 'Project Phase',
  },
});
